import { render, staticRenderFns } from "./EventsEditTabContent.vue?vue&type=template&id=77ce4ac6&"
import script from "./EventsEditTabContent.vue?vue&type=script&lang=js&"
export * from "./EventsEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./EventsEditTabContent.vue?vue&type=style&index=0&id=77ce4ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports